// extracted by mini-css-extract-plugin
module.exports = {"default":"AssetIcon_default__3bNYM","sm":"AssetIcon_sm__1l2zE","xs":"AssetIcon_xs__2Njew","lg":"AssetIcon_lg__K1zAf","idle":"AssetIcon_idle__10cRQ","load":"AssetIcon_load__PWbMd"};